import { promoDueDateFormat } from '../../../IPA/PlataformaPrecificacao/utils';

export function formatterXLabel(props) {
  return `<b>${props.value}</b>`;
}

export function formatterYLabel(props) {
  return `${props.value}%`;
}

export function formatSectionXLabel(position: number) {
  const number = position + 1;
  return `Seção ${number < 10 ? '0' + number : number}`;
}

export const seriesColors = ['#76D680', '#A371E2', '#DFA25B', '#F25E5E', '#609BCE', '#B30089', '#FFB46E', '#FFD76E', '#5FC8FF', '#FF73C3'];

export const HighchartsOptions = {
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    exitFullscreen: 'Sair da tela cheia',
  },
};

export const yAxis = data => {
  const newData = data?.map(item => item.coberturaTotal);
  return newData;
};

export const xAxis = data => {
  const newData = data?.map(item => promoDueDateFormat(item.dataFinal));
  return newData;
};
